import { SearchFilter } from '../../common/search-filter';

export class ConfirmingContractsSearchCriteria extends SearchFilter {
	public StartDateStart: Date | null;
	public StartDateEnd: Date | null;
	public ProductCodeList: string[];
	public ExternalId: string;
	public BuyerIdList: string[];
	public FinancierIdList: string[];
	public FinancierVatNumber: string;
	public BuyerVatNumber: string;
	public FinancierName: string;
	public BuyerName: string;
	public EndDateStart: Date | null;
	public EndDateEnd: Date | null;
	public ContractStateList: string[];
	public Currency: string;
}
